import { render, staticRenderFns } from "./MessageLog.vue?vue&type=template&id=037b4f0e&scoped=true"
import script from "./MessageLog.vue?vue&type=script&lang=js"
export * from "./MessageLog.vue?vue&type=script&lang=js"
import style0 from "./MessageLog.vue?vue&type=style&index=0&id=037b4f0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037b4f0e",
  null
  
)

export default component.exports